import { render, staticRenderFns } from "./StoreJoinTab.vue?vue&type=template&id=24a8f0b4&scoped=true&"
import script from "./StoreJoinTab.vue?vue&type=script&lang=js&"
export * from "./StoreJoinTab.vue?vue&type=script&lang=js&"
import style0 from "./StoreJoinTab.vue?vue&type=style&index=0&id=24a8f0b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a8f0b4",
  null
  
)

export default component.exports